import React from "react";
import { MapContent } from "src/content";

const Map = () => {
  return <MapContent />;
};

export default Map;
